// extracted by mini-css-extract-plugin
export default {"icon":"chartContainer_icon__LUy09"};